import { isEmpty, deepClone } from './helper';

/**
 * @description Function to check if values in 2 arrays are same and in the same order.
 * @param {arr1} value - First Array
 * @param {arr2} value - Second Array
 * @return {Boolean} - true/false
 */
export const isArrayValueAndOrderSame = (arr1, arr2) => JSON.stringify(arr1) === JSON.stringify(arr2);

/**
 * @description Function to get unique values from an array.
 * @param {arr} value - Array.
 * @return {Array} - Array with unique elements.
 */
export const getUniqueArrayValues = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Array.isArray(arr) ? [...new Set(arr)] : [];
};

/**
 * @description Function to check if an element is present inside an array
 * @param {arr} value - Array.
 * @param {Any} item - Element to be checked.
 * @return {Boolean} - true/false
 */
export const isItemInArray = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let item = arguments.length > 1 ? arguments[1] : undefined;
  if (Array.isArray(arr) && arr.indexOf(item) !== -1) {
    return true;
  }
  return false;
};

/**
 * @description Function to add item to list
 * @param {Array} list - list to add item
 * @param {any} item - item to add to the list
 * @return {Array} - mmodified list
 */
export const addItemToList = (list, item) => {
  if (isEmpty(list) && isEmpty(item)) {
    return [];
  }
  if (!Array.isArray(list) || isEmpty(list)) {
    return [item];
  }
  if (isEmpty(item)) {
    return list;
  }
  const newList = deepClone(list);
  return [...newList, item];
};

/**
 * @description Function to add item to list
 * @param {Array} list - list to add item
 * @param {Array} items - item to add to the list
 * @return {Array} - mmodified list
 */
export const addItemsToList = function () {
  let list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (isEmpty(list) && isEmpty(items)) {
    return list;
  }
  if (!Array.isArray(list) || isEmpty(list)) {
    return items;
  }
  if (isEmpty(items)) {
    return list;
  }
  const newList = deepClone(list);
  const listSet = new Set([...newList, ...items]);
  return [...listSet];
};

/**
 * @description Function to check if an element is last element
 * @param {arr} value - Array.
 * @param {Any} index - Element to be checked.
 * @return {Boolean} - true/false
 */
export const isLastInList = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  if (!Array.isArray(arr) || index === -1) {
    return false;
  }
  return arr.length - 1 === index;
};

/**
 * @description Function to remove item from list
 * @param {Array} list - list to remove item
 * @param {any} item - item to remove to the list
 * @return {Array} - mmodified list
 */
export const removeItemFromList = (list, item) => {
  if (isEmpty(list) && isEmpty(item)) {
    return [];
  }
  if (!Array.isArray(list) || isEmpty(list)) {
    return [item];
  }
  if (isEmpty(item)) {
    return list;
  }
  return list.filter(value => value !== item) || [];
};

/**
 * @description Function to return array of item if not already
 * @param {Any} val - any value
 * @return {Array} - return array formatted value
 */
export const getAsList = val => Array.isArray(val) ? val : [val];

/**
 * @description function to check array is empty
 * @param {any} item - item to check empty
 * @returns {boolean} true/false
 */
export const isEmptyList = item => {
  if (!Array.isArray(item)) {
    return true;
  }
  return item.length === 0;
};

/**
 * @description function to check list is valid
 * @param {any} list item to check for validity
 * @returns {boolean} true/false
 */
export const checkListValid = list => !(!Array.isArray(list) || !list.length);

/**
 * @description function to return Set from set of arrays
 * @param {array} list list from which empty items to be removed
 * @param {any} emptyVal empty value to be removed
 * @returns {array} non empty list
 */
export const removeEmptyItems = (list, emptyVal) => {
  if (isEmpty(list) || !Array.isArray(list)) {
    return list;
  }
  return list.filter(item => item !== emptyVal) || [];
};

/**
 * @description Function to get first element with default value sanity check
 * @param {Array} list - list of items
 * @param {Any} defaultVal - default value if list is not valid
 * @returns {Any} first item of list
 */
export const getFirstItemInList = (list, defaultVal) => {
  if (!Array.isArray(list) || isEmpty(list)) {
    return defaultVal;
  }
  return list[0];
};

/**
 * @description Function to get unique objects from an array.
 * @param {arr} value - Array.
 * * @param {key} value - string.
 * @return {Array} - Array with unique objects.
 */
export const getUniqueArrayofObjects = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let key = arguments.length > 1 ? arguments[1] : undefined;
  return Array.isArray(arr) ? [...new Map(arr.map(item => [item[key], item])).values()] : [];
};